<template>
  <div class="etb">
    <div class="etb__key">
      <p class="etb__key__p">{{this.title}}</p>
    </div>
    <div class="etb__value">
      <div class="etb__value--display" v-if="!editing">
        <p class="etb__value__p">{{this.convertedValue}}</p>
        <div class="etb__value__edit">
          <a href="#" @click.prevent='start_editing' title="修改">
            <img src="@/assets/icon/baseline_create_black_18dp.png" alt="">
          </a>
        </div>
      </div>
      <div class="etb__value--editing" v-if="editing">
        <input :type="this.type" class="etb__value__input" v-model="newValue">
        <div class="etb__value__done">
          <a href="#" @click.prevent="complete_editing" v-if="type !== 'password'">
            儲存
          </a>
          <a href="#" @click.prevent="giveup_editing">
            放棄
          </a>
        </div>
      </div>
      <div class="etb__value--editing" v-if="editing && type === 'password'">
        <input :type="this.type" class="etb__value__input" v-model="newValue"
        placeholder="請再次輸入">
        <div class="etb__value__done">
          <a href="#" @click.prevent="complete_editing_password">
            儲存
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'k', 'value', 'type'],
  computed: {
    members() {
      let m;
      this.$bus.$on('son_get_data', (data) => {
        m = data.members;
      });
      this.$bus.$emit('son_call_data');
      return m;
    },
    convertedValue() {
      const v = this.type === 'password' ? 'XXX密碼XXX' : this.value;
      return v;
    },
  },
  data() {
    return {
      editing: false,
      newValue: '',
      confirmPassword: '',
    };
  },
  methods: {
    start_editing() {
      if (this.type === 'password') {
        this.newValue = '';
      } else {
        this.newValue = this.value;
      }
      this.editing = true;
    },
    complete_editing() {
      const mailRepeat = this.confirm_email_repeated();
      if (!mailRepeat) {
        this.$emit('emit_newValue', this.k, this.newValue);
        this.editing = false;
      } else {
        alert('電子信箱重複，請使用另一個電子信箱');
        this.newValue = '';
      }
    },
    complete_editing_password() {
      if (this.newValue === this.confirmPassword) {
        this.complete_editing();
      } else {
        alert('再次輸入密碼不一致');
        this.newValue = '';
        this.confirmPassword = '';
      }
    },
    giveup_editing() {
      this.editing = false;
      this.newValue = '';
      this.confirmPassword = '';
    },
    confirm_email_repeated() {
      const repeat = this.members.find((item) => item.email === this.newValue);
      return repeat;
    },
  },
};
</script>
